export class Ticket {

    public idTicketControl: number;
    public dtTckEnd: any;
    public dtTckStart: any;
    public numTck: number;
    public comments: string;
    
}
